export default [
  {
    name: 'Partner.Agreement',
    // тут нужно оставить пустую строку,
    // дабы этот роут не добавлялся в URL к дочерним
    path: '',
    component: () => import('./components/organizations/Agreement'),
    children: [
      {
        name: 'Partner.Organizations',
        path: 'organizations',
        component: () => import('./components/organizations/List')
      },
      {
        name: 'Partner.Organizations.Edit',
        path: 'organizations/:id?/edit',
        props: true,
        component: () => import('./components/organizations/Edit')
      }
    ]
  },
  {
    name: 'Partner.Offices.Edit',
    path: 'organizations/:organizationId/offices/:id?/edit',
    props: true,
    component: () => import('./components/offices/Edit')
  },
  {
    name: 'Partner.Actions.Edit',
    path: 'organizations/:organizationId/actions/:id?/edit',
    props: true,
    component: () => import('./components/actions/Edit')
  },
  {
    name: 'Partner.BuldingSchedule',
    path: 'building-schedule',
    component: () => import('./components/building-schedule/List')
  }
]
